import { Controller } from "@hotwired/stimulus"
import moment from 'moment'

export default class extends Controller {
  connect() {
    document.querySelector('#recipient_type_member').addEventListener('change', this.selectRecipientType.bind(this))
    document.querySelector('#recipient_type_facility').addEventListener('change', this.selectRecipientType.bind(this))
  }

  sendFormRequest() {
    const facility = $('#affiliate_facility_id').val();
    const member = $('#member_id').val();
    const organization = $('#organization_id').val();
    var url = `/organizations/${organization}/facilities/${facility}/create_form_request.turbo_stream`
    if (document.querySelector('#member_select_wrapper').style.display === 'block'){
      url = `/organizations/${organization}/affiliate_members/${member}/create_form_request.turbo_stream`
    }
    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': token,
        'Accept': 'text/vnd.turbo-stream.html'
      },
      body: JSON.stringify({ token: $('#form_id').val() })
    }).then(response => {
      if (response.ok) {
        return response.text();
      }
    }).then(turboStreamHTML => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = turboStreamHTML;

      const turboStreamElement = tempDiv.querySelector('turbo-stream');
      if (turboStreamElement) {
        document.getElementById('flash_messages_div').innerHTML = turboStreamElement.querySelector('template').innerHTML;
      }
      $('#send_request_modal').modal('hide')
    })
  }

  selectRecipientType(event) {
    const type = event.target.value
    document.querySelector('#member_select_wrapper').style.display = type === "member" ? "block" : "none"
    document.querySelector('#facility_select_wrapper').style.display = type === "facility" ? "block" : "none"
  }

  setForm(event) {
    const modal = document.getElementById('send_request_modal');
    if (modal) {
      modal.addEventListener('hidden.bs.modal', this.resetModal());
    }

    if (this.isFormRowWithTitle(event.target)) {
      this.setupAddNewFacilityForm();
      $('#form_id').val(event.target.dataset.form);
    } else {
      $('#form_id').val(event.target.dataset.form);
    }
  }

  isFormRowWithTitle(clickedElement) {
    const row = clickedElement.closest('tr');
    if (!row) return false;
    const title = row.querySelector('td:first-child').textContent.trim();
    if (title === 'Add New Facility'){
      return true;
    }

    return false;
  }

  setupAddNewFacilityForm() {
    const radioContainer = document.querySelector('.form-check');
    if (radioContainer) {
      radioContainer.style.display = 'none';
    }

    const memberWrapper = document.getElementById('member_select_wrapper');
    if (memberWrapper) {
      memberWrapper.style.display = 'block';
    }

    const questionText = document.querySelector('#send_request_modal .modal-body p:first-child')
    if (questionText) {
      questionText.textContent = 'Which member do you want to send your form request?'
    }

    const facilityRadio = document.getElementById('recipient_type_facility')
    const facilityLabel = document.querySelector('label[for="recipient_type_facility"]')
    if (facilityRadio && facilityLabel) {
      facilityRadio.style.display = 'none'
      facilityLabel.style.display = 'none'
    }
  }

  resetModal() {
    const memberRadio = document.getElementById('recipient_type_member');
    const facilityRadio = document.getElementById('recipient_type_facility');
    const memberLabel = document.querySelector('label[for="recipient_type_member"]');
    const facilityLabel = document.querySelector('label[for="recipient_type_facility"]');
    const radioContainer = document.querySelector('.form-check');
    if (radioContainer) {
      radioContainer.style.display = 'block';
    }

    if (facilityRadio) facilityRadio.style.display = '';
    if (facilityLabel) facilityLabel.style.display = '';
    if (memberRadio) memberRadio.checked = false;
    if (facilityRadio) facilityRadio.checked = false;

    const memberWrapper = document.getElementById('member_select_wrapper');
    const facilityWrapper = document.getElementById('facility_select_wrapper');
    if (memberWrapper) memberWrapper.style.display = 'none';
    if (facilityWrapper) facilityWrapper.style.display = 'none';

    const questionText = document.querySelector('#send_request_modal .modal-body p:first-child');
    if (questionText) {
      questionText.textContent = 'Do you want to send your form request to a member or facility?';
    }

    const form = this.element.closest('form');
    if (form) form.reset();
  }
}
